














import { Component, Prop, Vue, Emit ,Watch} from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';
// import { WorkflowAction } from '../models/workflowAction';

@Component
export default class Workflow extends Vue {
  @Prop() public item: Common.StateObject;
  @Prop() public index: number;
  @Prop({default:false}) public isToolbar: boolean;
  @Prop({default:null}) public statusList: string;
  @Prop({ default: null }) public perm: string;
  @Prop({default: null}) public preSendAction:(item :Common.StateObject, action:Common.WorkflowAction)=>{};

  public actions: Common.WorkflowAction[] = new Array();

  showDialog:boolean = false;
  dialogCaption:string = '';
  dialogMessage:string = '';
  onExecute = ()=>{};

　public created(){
    this.actions = this.$api.perms.getWorkflowActions(this.item.workflowCode, this.item.workflowId,this.item.workflowStateId);
  }

  public get isValid():boolean{
    return this.item && (this.item instanceof Common.StateObject);
  }
  @Watch('item')
  public onItemChanged()
  {
    this.actions = this.$api.perms.getWorkflowActions(this.item.workflowCode, this.item.workflowId,this.item.workflowStateId);
    this.$forceUpdate();
  }
  //workflowIdとworkflowStatusIdにもとづいて現在のステータス・sendアクション(複数)を取得・表示する。
  //historyがある場合はsendbackアクションを表示する。


  public get sendClass(): string{
    const state = this.$api.perms.getWorkflowState(this.item.workflowCode, this.item.workflowId,this.item.workflowStateId);
    //終端点は灰色にする
    if ((state.type & Common.StateTypes.ExitStatus) == Common.StateTypes.ExitStatus) return 'cx_workflow_inactive'
    else return 'cx_workflow_active';
  }

  public get backVisible(): boolean {
    if (!this.item.workflowCode) return false;
    const state = this.$api.perms.getWorkflowState(this.item.workflowCode, this.item.workflowId,this.item.workflowStateId);
    //開始点以外でUserStatusの場合に差戻しボタンを表示する
    return (state.type & Common.StateTypes.EntryStatus) != Common.StateTypes.EntryStatus && (state.type & Common.StateTypes.UserStatus) == Common.StateTypes.UserStatus;
  }


  public get disabled(): boolean {
    //アクセス権限がない場合も非活性にする
    return this.$api.perms.hasWorkflowPermission(this.item.workflowHolder) == false || this.$api.perms.hasMenuPermission(this.perm) == false;
  }

  public get backDisabled(): boolean {
    //取戻権限を承認履歴に基づいて判定する処理をなくす=誰でも押せる
    return false;

    // //最終アクションのユーザーを取得して自分自身だった場合は、有効化(disable=false)する
    // //const matches = this.item.workflowHistory != null ? this.item.workflowHistory.match(/(?<="userId":")[^"]*(?="[^¥{]*$)/):null;
    // const matches = this.item.workflowHistory != null ? this.item.workflowHistory.match(/"userId":"[^"]*(?="[^¥{]*$)/):null;
    // const ownAction = matches != null && matches[0] == '"userId":"' + this.$api.auth.userId;
    // return (this.$api.perms.hasWorkflowPermission(this.item.workflowHolder) == false) && (ownAction == false);
  }
  public suppressClick(){
    //modalからのクリック伝搬を阻止
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
  }
  // ワークフローアクションに帳票がセットされている場合ダイアログの表示を変える
  public workflowAction: Common.WorkflowAction = null;
  public async send(stateId:number, actionName:string, action:Common.WorkflowAction) {
      if(this.preSendAction) await this.preSendAction(this.item, action);
      this.dialogCaption = actionName;      
      this.workflowAction = action;
      this.showModal(true,stateId);

      this.suppressClick();
  }
  public sendBack() {
      this.dialogCaption = '差戻';   
      this.showModal(false);
      this.suppressClick();
  }

  public getItemWithMessage(){
    if (this.dialogMessage != ''){
        const msg = new Common.WorkflowMessage();
        msg.userId = this.$api.auth.userId;
        msg.isNote = false;
        msg.destination = ''; //宛先はサーバー側で更新する
        msg.description = this.dialogMessage;
        msg.timeStamp = null; //新規メッセージをマークする
                
        // const result = new Array<Common.WorkflowMessage>();
        // if (this.item.workflowMessage){
        //   (JSON.parse(this.item.workflowMessage) as Array<any>).forEach(source => {
        //     const target = new Common.WorkflowMessage();
        //     Object.assign(target, source);
        //     result.push(target);
            
        //   });
        // }
        // result.sort((a,b)=> a.timeStamp > b.timeStamp ? -1 : 1);//降順ソート
        // result.unshift(msg);

        // this.item.workflowMessage = JSON.stringify(result);

        this.item.workflowMessage = msg;
    }

    return this.item;
  }
  public onHide(){
     this.showDialog= false;
  }

  public showModal(isSend:boolean, stateId :number = 0){
        let componentClass = Vue.extend(Components.WorkflowDialog);
        var router = this.$router;
        let instance = new componentClass({
            router,
            propsData: {
              dialogCaption :this.dialogCaption,
              isSend :isSend,
              item: this.item,
              stateId: stateId,
              workflowAction: this.workflowAction,
              onUpdate:  (obj:any) => {       
                  this.$emit('updated',this.index, obj);  //ダイアログが先に閉じるためイベント処理できない   
              }
            },
          });
        //テナント設定のワークフロー確認画面表示フラグがオフで、メール送信設定がない場合は実行処理を直接呼出し、確認画面の表示を省略する
        if (this.$api.tenantSettings && this.$api.tenantSettings.showWorkflowConfirm == false &&  (this.workflowAction && this.workflowAction.isShowSendReport == false)) {
          (instance as Components.WorkflowDialog).onExecute(null);
          return;
        }

        instance.$mount();
        instance.$on('hidden', () => {       
          //destroyできない
          instance.$el.parentElement.removeChild(instance.$el);
          instance.$destroy();
        });
        this.$root.$el.appendChild(instance.$el);        //ルートにマップする
  }
}
